import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Modal, Button, Dropdown, Spinner } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import RoutingSlip from "../RoutingSlip/RoutingSlip";
import "./Modal.css";

function RoutingSlipModal({
  show,
  onHide,
  customerDetail,
  allBooking,
  bookingData,
  transactionNo,
  queueNo,
  onPrintDone,
  isLoading,
}) {
  const printRef = useRef(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [selectedSize, setSelectedSize] = useState("A4");
  const [pageStyle, setPageStyle] = useState(
    "@page { size: A4; margin: 0; } body { -webkit-print-color-adjust: exact; }"
  );
  
  const doPrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle,
    onAfterPrint: () => {
      setIsPrinting(false);
    },
  });

  const handlePrint = (paperSize = "A4") => {
    if (isPrinting) return;
    setIsPrinting(true);
    setSelectedSize(paperSize);
    setPageStyle(`@page { size: ${paperSize}; margin: 0; } body { -webkit-print-color-adjust: exact; }`);
    
    // Give time for state to update and layout to settle
    setTimeout(() => {
      doPrint && doPrint();
    }, 300);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      size="md"
      centered
      className="routing-slip-modal"
    >
      <Modal.Body className="d-flex flex-column align-items-center justify-content-center">
        <Dropdown className="mb-3">
          <Dropdown.Toggle variant="light" id="routing-slip-dropdown">
            Routing Slip
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handlePrint("A4")}>
              Print A4
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handlePrint("A5")}>
              Print A5
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Button variant="primary" onClick={onPrintDone} disabled={isPrinting || isLoading}>
          {isLoading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Done
            </>
          ) : (
            "Done"
          )}
        </Button>

        {/* HIDDEN PRINT CONTENT - Always in DOM when modal is open for robust printing */}
        <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
          <div ref={printRef}>
            <RoutingSlip
              customerDetail={customerDetail}
              allBooking={allBooking}
              bookingData={bookingData}
              transactionNo={transactionNo}
              queueNo={queueNo}
              pageSize={selectedSize}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RoutingSlipModal;
